import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { Assistance } from '../../../../core/models/assistance.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { ServiceAssistance } from '../../../../core/services/assistance/assistance-service';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { AssistanceForm } from '../assistance-form/assistance-form';
import { AssistanceAssistanceserviceList } from '../../assistanceservice/assistance-assistanceservice-list/assistance-assistanceservice-list';
import { MatMenuModule } from '@angular/material/menu';
import { AssistanceserviceForm } from '../../assistanceservice/assistanceservice-form/assistanceservice-form';
import { AssistanceService } from '../../../../core/models/assistanceservice.interface';
import { AssistanceserviceService } from '../../../../core/services/assistanceservice/assistanceservice-service';
import { MatDividerModule } from '@angular/material/divider';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-assistance-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
    AssistanceAssistanceserviceList,
    MatMenuModule,
    MatDividerModule,
    TermPipe,
  ],
  templateUrl: './assistance-list.html',
  styleUrl: './assistance-list.scss',
})
export class AssistanceList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  private sectorName: string | null = null;
  serviceassistance: Assistance[] = [];
  asyncAssistance!: Observable<Assistance[]>;
  searchassistance: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  termKey = TermKey;
  showColumns: string[] = [
    'controls',
    'id',
    'name',
    'population',
    'sector',
    'sourceFoundings',
    'description',
    'total',
  ];

  expandedRows = new Set<number>();

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private assistanceService: ServiceAssistance,
    private assistanceserviceService: AssistanceserviceService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Asistencias');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchAssistance(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();

    this.layoutService.sectorSelected$.subscribe((sector) => {
      this.sectorName = sector?.name ?? null;
      this.fetchAssistance(1);
    });
  }

  fetchAssistance(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    const sectorName = this.layoutService.getSectorSelected()?.name;
    if (sectorName) {
      params.filters.push({ name: 'sector__name', value: sectorName } as Filter);
    }

    this.page = page;
    this.loadingService.show(true);
    this.asyncAssistance = this.assistanceService.getAssistance(params).pipe(
      tap((data) => {
        this.serviceassistance = data.results;
        this.assistanceService.setAssistance(data.results[0]);
        this.assistanceService.setAssistances(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }
  createAssistance() {
    this.assistanceService.removeAssistanceSelected();
    const dialogRef = this.dialog.open(AssistanceForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchAssistance(this.page);
    });
  }

  updateAssistance(assistance: Assistance) {
    this.assistanceService.setAssistance(assistance);
    const dialogRef = this.dialog.open(AssistanceForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchAssistance(this.page);
    });
  }

  eliminate(assistance: Assistance): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${assistance.name}?`);
    if (!confirmed) return;
    this.assistanceService.delete(assistance.id).subscribe({
      next: () => {
        this.toastr.success('Eliminado CORRECTAMENTE!', 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchAssistance(this.page);
      },
      error: () => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }

  addAsistanceService(assistance: Assistance): void {
    this.assistanceService.setAssistance(assistance);
    this.assistanceserviceService.removeAssistanceServiceSelected();
    this.expandedRows.add(assistance.id);
    const dialogRef = this.dialog.open(AssistanceserviceForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: { isCreate: true, assistanceId: assistance.id },
    });
    dialogRef.afterClosed().subscribe(() => this.fetchAssistance(this.page));
  }

  toggleServices(assistance: Assistance): void {
    if (this.expandedRows.has(assistance.id)) {
      this.expandedRows.delete(assistance.id);
      return;
    }
    this.expandedRows.add(assistance.id);
  }

  isExpanded(id: number): boolean {
    return this.expandedRows.has(id);
  }
}
